import React, { useState } from "react";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { enqueueSnackbar } from "notistack";
import callApi from "../helpers/callApi";
import { exportRoute } from "../helpers/evalComparisonApi";

// A byte order mark so spreadsheets read accented letters in UTF-8.
const BOM = "﻿";

const download = ({ filename, content }) => {
  const blob = new Blob([BOM + content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

// Downloads every row that matches the current view. Core builds the file
// (only the server has every row); this button asks for it and saves it.
const ExportCsvButton = ({ tag, view, batchId, pinned, token, loading, total }) => {
  const [exporting, setExporting] = useState(false);

  let reason = null;
  if (loading) reason = "The rows are still loading";
  else if (!total) reason = "There is nothing to download";

  const handleClick = async () => {
    setExporting(true);
    try {
      download(await callApi(exportRoute({ tag, view, batchId, pinned }), "GET", undefined, token));
    } catch (err) {
      enqueueSnackbar(err.message, { variant: "error" });
    } finally {
      setExporting(false);
    }
  };

  // The reason shows as text, and the button points to it, so keyboard and
  // screen reader users get it too.
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {reason && (
        <Typography id="export-csv-reason" variant="caption" color="text.secondary">
          {reason}
        </Typography>
      )}
      <Button
        variant="outlined"
        startIcon={exporting ? <CircularProgress size={16} /> : <DownloadIcon />}
        onClick={handleClick}
        disabled={Boolean(reason) || exporting}
        aria-describedby={reason ? "export-csv-reason" : undefined}
        title={reason ? undefined : `Download all ${total} matching rows`}
      >
        Download CSV
      </Button>
    </Stack>
  );
};

export default ExportCsvButton;
